export default "__VITE_ASSET__BT9RM9Es__"